 <div class="projects mb-4">
        <div class="card">
                <div class="card-header header-background">
                      <div class="row">
                          <div class="col-sm-3">
                              <h2>Consolidado</h2>
                          </div>
                      </div>
                </div>
        
                <div style="margin: 1rem;
                border-style: none;">
                    <!-- <div>
                        <button mat-raised-button class="btn-nueva" (click)="crearCuentaJardin()"><mat-icon>add</mat-icon> Crear Cuenta</button>
                        <mat-form-field class="filtro-input">               
                            <input matInput #palabraClave type="search" placeholder="Palabra clave...">
                            <button mat-button matSuffix mat-stroked-button aria-label="search" (click)="buscar(palabraClave)">
                            Buscar
                        </button>
                        </mat-form-field>
                    </div> -->
                    
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-lg-1">
                            <p class="title-descriptor">Filtrar Por:</p>
                        </div>
                        <div class="col-lg-2">
                            <mat-form-field>
                                
                                <mat-label>Región</mat-label>
                                <mat-select id="region" name="region" class="selectMedio"  (selectionChange)="seleccionarRegion($event.value)">
                                    <mat-option [value]="0">Seleccione Región</mat-option>
                                    <mat-option [value]="regiones.idRegion" *ngFor="let regiones of regiones">{{regiones.nombre}}</mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="hasError('region', 'required')">Región es requerido</mat-error>
                                <mat-error *ngIf="hasError('region', 'min')">Región es requerido</mat-error> -->
                            </mat-form-field>  
                        </div>
                        <div class="col-lg-2">
                            <mat-form-field>
                                <mat-label>Comuna</mat-label>
                                <mat-select id="comuna" class="selectMedio" name="comuna" (selectionChange)="seleccionarComuna($event.value)">
                                    <mat-option [value]="0">Seleccione Comuna</mat-option>
                                    <mat-option [value]="comunas.idComuna" *ngFor="let comunas of arrayComunas">{{comunas.nombre}}</mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="hasError('comuna', 'required')">Comuna es requerido</mat-error>
                                <mat-error *ngIf="hasError('comuna', 'min')">Comuna es requerido</mat-error> -->
                            </mat-form-field>   
                        </div>
                        <div class="col-lg-2">
                            <mat-form-field>
                                <mat-label>Programa</mat-label>
                                <mat-select  placeholder="" floatlLabel="never" id="programa" class="selectMedio" name="programa" (selectionChange)="seleccionarPrograma($event.value)">
                                    <mat-option value="0">Seleccione Programa</mat-option>
                                    <mat-option [value]="programas.idTablaMaestra" *ngFor="let programas of programas">{{programas.descripcionLarga}}</mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="hasError('programa', 'required')">Programa es requerido</mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-lg-5 d-flex justify-content-end" >
                          <input class="form-control me-sm-2" type="text" (keyup.enter)="buscar(palabraClave)" [(ngModel)]="palabraClave" style="width: 300px; height: 45px;" placeholder="Buscar">
                                  <button class="btn btn-secondary" type="submit" (click)="buscar(palabraClave)" style="width: 130px;height: 45px;"><i class="fas fa-search"></i> Buscar</button>
                        </div>
                      </div>

                      <div class="row">
                        <div class="d-flex justify-content-end">
                            <a class="btn" [attr.href]="apiEndpoint + 'adminUsuarioInformes/4'" target=”_blank”  style="width: 40px;border-radius: 50%;background-color: #597CEE;color: #fff;"> <i class="fas fa-download"></i> </a>
                        </div>
                      </div>
                
                    <div>
                    <!-- <div class="example-loading-shade"
                            *ngIf="isLoadingResults">
                        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                    </div> -->
                
                        <table class="tables-info" mat-table [dataSource]="dataSource" matSort>
                
                            <ng-container matColumnDef="region">
                                <th mat-header-cell *matHeaderCellDef > Región </th>
                                <td mat-cell *matCellDef="let row" > {{row.region}} </td>
                            </ng-container>
                
                            <ng-container matColumnDef="comuna">
                                <th mat-header-cell *matHeaderCellDef > Comuna </th>
                                <td mat-cell *matCellDef="let row" > {{row.comuna}} </td>
                            </ng-container>
                
                            <ng-container matColumnDef="programa">
                                <th mat-header-cell *matHeaderCellDef > Programa </th>
                                <td mat-cell *matCellDef="let row" > {{row.programa}} </td>
                            </ng-container>
                
                            <ng-container matColumnDef="codigo">
                                <th mat-header-cell *matHeaderCellDef > Código JI </th>
                                <td mat-cell *matCellDef="let row" > {{row.codigo}} </td>
                            </ng-container>
                
                            <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef > Nombre JI </th>
                                <td mat-cell *matCellDef="let row" > {{row.nombre}} </td>
                            </ng-container>

                            <ng-container matColumnDef="capacitacion">
                                <th mat-header-cell *matHeaderCellDef class="centre"> CAPACITACIÓN</th>
                                <td mat-cell *matCellDef="let row" class="centre"> 
                                    <div *ngIf="row.capacitacion==1"><p style="color: #EE366D;">No Iniciada</p></div> 
                                    <div *ngIf="row.capacitacion==2"><p style="color: #F5BB3F;">En Proceso</p></div> 
                                    <div *ngIf="row.capacitacion==3"><p style="color: #00B09E;">Finalizada</p></div> 
                                </td>
                            </ng-container>
                            
                            <ng-container matColumnDef="autoevaluacion">
                                <th mat-header-cell *matHeaderCellDef class="centre"> AUTOEVALUACIÓN</th>
                                <td mat-cell *matCellDef="let row" class="centre"> 
                                    <div *ngIf="row.autoevaluacion==1"><p style="color: #EE366D;">No Iniciada</p></div> 
                                    <div *ngIf="row.autoevaluacion==2"><p style="color: #F5BB3F;">En Proceso</p></div> 
                                    <div *ngIf="row.autoevaluacion==3"><p style="color: #00B09E;">Finalizada</p></div> 
                                </td>
                            </ng-container>
                
                            <ng-container matColumnDef="validacion">
                                <th mat-header-cell *matHeaderCellDef class="centre"> VALIDACIÓN</th>
                                <td mat-cell *matCellDef="let row" class="centre">
                                    <div *ngIf="row.validacion==1"><p style="color: #EE366D;">No Iniciada</p></div> 
                                    <div *ngIf="row.validacion==2"><p style="color: #F5BB3F;">En Proceso</p></div> 
                                    <div *ngIf="row.validacion==3"><p style="color: #00B09E;">Finalizada</p></div>
                                </td>
                            </ng-container>
                
                            <ng-container matColumnDef="planMejora">
                                <th mat-header-cell *matHeaderCellDef class="centre"> PLAN DE MEJORA</th>
                                <td mat-cell *matCellDef="let row" class="centre">
                                    <div *ngIf="row.planMejora==1"><p style="color: #EE366D;">No Iniciada</p></div> 
                                    <div *ngIf="row.planMejora==2"><p style="color: #F5BB3F;">En Proceso</p></div> 
                                    <div *ngIf="row.planMejora==3"><p style="color: #00B09E;">Finalizada</p></div>
                                </td>
                            </ng-container>
            
                
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                
                        <mat-paginator
                            [length]="length"
                            [pageIndex]="pageIndex"
                            
                            [pageSizeOptions]="[10, 50, 100]"
                            [showFirstLastButtons]="true"
                            (page)="getServerData($event)">
                        </mat-paginator>
                    </div>
                </div>
        
                
        </div>
  
    </div>
    
    <ngx-spinner></ngx-spinner>